<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Skip to main content link for accessibility -->
    <a 
      href="#main-content" 
      class="skip-link"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
    
    <AppHeader />
    <main id="main-content" role="main">
      <RouterView />
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
</script>

<style scoped>
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #7f1d1d;
  color: white;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 0 0 4px 0;
  z-index: 1000;
  font-weight: 600;
}

.skip-link:focus {
  top: 0;
}
</style>
